<div class="table-layout">
  <div class="table-container" #tableContainer>
    <table [id]="id" appTable [tableLayoutAuto]="tableLayoutAuto">
      <thead>
        @for (row of headerRows; track row) {
          <ng-container #headersVcr></ng-container>
        }
      </thead>
      <tbody [ngSwitch]="currentTemplate">
        <ng-container *ngSwitchCase="'loadingBlock'">
          @for (row of Array.from(Array(limit).keys()); track row) {
            <tr class="disabled">
              @for (cell of headers.toArray(); track cell) {
                <td>
                  <ngx-skeleton-loader></ngx-skeleton-loader>
                </td>
              }
            </tr>
          }
        </ng-container>
        <ng-container *ngSwitchCase="'dataBlock'">
          @for (row of rows; track row) {
            <ng-container #rowsVcr></ng-container>
          }
        </ng-container>
        <ng-container *ngSwitchCase="'messageBlock'">
          <tr class="message no-data disabled">
            <td [colSpan]="headers.length">
              <div class="no-data-block">
                <img [src]="noFilteredDataMessage.imgSrc" alt="no_data_image" />
                <span [innerHTML]="isFiltered ? noFilteredDataMessage.title : messageInfo"></span>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
  <div [class.hidden-footer]="currentTemplate !== 'dataBlock' || !showFooter">
    <app-table-footer
      [source]="displayedSource"
      [(limit)]="limit"
      [(currentPage)]="currentPage"
      [pageable]="pageable"
      [limits]="limits"
      (limitChange)="onLimitChange($event)"
      (currentPageChange)="onPageChange($event)"
    >
    </app-table-footer>
  </div>
</div>
